import { render, staticRenderFns } from "./InteractionChoiceContainer.vue?vue&type=template&id=8fd1ea18"
import script from "./InteractionChoiceContainer.vue?vue&type=script&lang=js"
export * from "./InteractionChoiceContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports